<template>
  <v-row class="pa-0 ma-0">
    <v-col cols="12" class="pa-0">
      <v-card flat color="transparent">
        <v-card-text class="py-0">
          <v-sheet color="transparent">
            <v-row class="ma-0 px-0 py-0" align="center">
              <v-col cols="12" class="pa-0 b-B-GREY-DARK" align="center">
                <v-row align="center" justify="center" style="height:48px;">
                  <template v-for="(header, index) in headers">
                    <v-col :cols="header.width"  :align="header.align" class="pa-0" :key="header.key">
                      <template v-if="header.valid">
                        <v-sheet class="pa-0 customHeader" color="transparent">
                          <span @click="onSort(index)" class="pa-0" @mouseenter="onMouse(index, true)" @mouseleave="onMouse(index, false)">{{ header.title }}</span>
                          <v-icon :color="headers[index].over ? 'grey' : 'transparent'">{{ getSortIcon(index) }}</v-icon>
                        </v-sheet>
                      </template>
                      <template v-else>
                        <span>{{ header.title }}</span>
                      </template>
                    </v-col>
                  </template>
                  <v-col class="pa-0" align="center">
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="pa-0" align="center">
                <div class='overflow-y-auto' :style="contentsHeight">
                  <RecycleScroller
                    class="scroller"
                    :items="myUsers"
                    :item-size="44"
                    key-field="key"
                  >
                    <template v-slot="{ item, index }">
                      <v-sheet :color="'transparent'" height="44" class="b-B-GREY">
                        <v-row class="ma-0 pa-0 customLine" align="center" style="height: 44px;">
                          <template v-for="(header) in headers">
                            <v-col :cols="header.width" class="pa-0" :align="header.align" @click.stop="onEdit(item)" :key="header.key">
                              <template v-if="header.key == 'number'">
                                <span class="overflow-text-hidden">{{ index + 1 }}</span>
                              </template>
                              <template v-if="header.key == 'displayName'">
                                <v-row class="ma-0 pa-0" align="center">
                                  <v-col cols="2" class="pa-0">
                                    <v-avatar size="30">
                                      <img v-if="item.photoURL" :src="item.photoURL">
                                    </v-avatar>
                                  </v-col>
                                  <v-col class="pa-0">
                                    <v-row class="ma-0">
                                    <span class="overflow-text-hidden caption">{{ item[header.key] }}</span>
                                    </v-row>
                                    <v-row justify="start" class="mx-2">
                                    <span class="overflow-text-hidden caption"><tt>{{ item['key'] }}</tt></span>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </template>
                              <template v-else-if="header.key == 'enableType'">
                                <v-chip x-small :color="item.disabled ? 'error' : 'primary'"><span >{{ item.disabled ? '無効' : '有効' }}</span></v-chip>
                              </template>
                              <template v-else-if="header.key == 'createdAt'">
                                <span class="caption">{{ item.createdAt | moment }}</span>
                              </template>
                              <template v-else>
                                <span class="overflow-text-hidden caption">{{ item[header.key] }}</span>
                              </template>
                            </v-col>
                          </template>
                        </v-row>
                      </v-sheet>
                    </template>
                  </RecycleScroller>
                </div>
              </v-col>
            </v-row>
          </v-sheet>
        </v-card-text>
      </v-card>
    </v-col>

    <div class="text-center">
      <v-layout row justify-center align-center>
        <v-dialog
          v-model='loading'
          persistent
          width="60">
          <v-card>
            <v-progress-circular
              indeterminate
              color="primary">
            </v-progress-circular>
          </v-card>
        </v-dialog>
      </v-layout>
    </div>

    <v-dialog v-model="dialog"
      hide-overlay
      fullscreen
      transition="dialog-bottom-transition"
      scrollable
      >
      <app-account-dialog
        v-if='dialog'
        @dismissed="onDismissed"
        :item="item"
        :type="'view'">
      </app-account-dialog>
    </v-dialog>
  </v-row>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import { mapGetters } from 'vuex'
import AccountDialog from '../admin/TemplateAccount.vue'
Vue.component('app-account-dialog', AccountDialog)

export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      windowSize: 'shared/windowSize'
    }),
    myUsers () {
      var temp = []
      for (var i in this.users) {
        var payload = JSON.parse(JSON.stringify(this.users[i]))
        temp.push(payload)
      }
      var key = null
      for (i in this.headers) {
        if (this.headers[i].value) {
          key = this.headers[i].key
          if (this.headers[i].value === 1) {
            temp.sort(function (a, b) {
              if (a[key] > b[key]) return -1
              if (a[key] < b[key]) return 1
              return 0
            })
          } else {
            temp.sort(function (a, b) {
              if (a[key] < b[key]) return -1
              if (a[key] > b[key]) return 1
              return 0
            })
          }
          break
        }
      }
      return temp
    },
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 48 - 2 - 40) + 'px;'
    }
  },
  data () {
    return {
      dialog: false,
      loading: false,
      type: null,
      headers: [
        { valid: false, over: false, value: 0, title: '#', key: 'number', width: '1', align: 'center' },
        { valid: true, over: false, value: 0, title: 'key', key: 'key', width: '3', align: 'start' },
        { valid: true, over: false, value: 0, title: 'email', key: 'email', width: '3', align: 'start' },
        { valid: true, over: false, value: 0, title: '名前', key: 'name', width: '2', align: 'start' },
        { valid: true, over: false, value: 0, title: '作成日', key: 'createdAt', width: '2', align: 'start' },
        { valid: false, over: false, value: 0, title: '状態', key: 'enableType', width: '1', align: 'start' }
      ],
      sortIcons: [
        'mdi-menu-swap',
        'mdi-menu-down',
        'mdi-menu-up'
      ],
      accounts: null,
      item: null,
      search: null,
      school: null
    }
  },
  created () {
  },
  methods: {
    onDismissed: function (value) {
      this.dialog = false
    },
    onCreate () {
      this.type = 'add'
      this.item = null
      this.dialog = true
    },
    onEdit (item) {
      this.type = 'edit'
      this.item = JSON.parse(JSON.stringify(item))
      this.dialog = true
    },
    getSortIcon (item) {
      return this.sortIcons[this.headers[item].value]
    },
    onMouse (item, value) {
      this.headers[item].over = value
    },
    onSort (item) {
      var temp = this.headers[item].value += 1
      if (temp === 3) {
        temp = 0
      }
      for (var i in this.headers) {
        this.headers[i].value = 0
      }
      this.headers[item].value = temp
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY-MM-DD HH:mm')
    }
  }
}
</script>

<style scoped>
.scroller {
  height: 100%;
}
.customHeader {
  cursor: pointer;
  user-select: none;
}
.customLine {
  cursor: pointer;
  user-select: none;
}
.customLine:hover {
  background-color: #CCCCCC20;
}
.b-B {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-B-GREY-DARK {
  border-bottom: 1px solid grey !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
